var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "personalDetails",
      attrs: {
        inline: true,
        model: _vm.personalDetails,
        "label-width": "124px",
        disabled: true,
        size: "small"
      }
    },
    [
      _c("el-form-item", { attrs: { label: "Επώνυμο" } }, [
        _vm._v("\n    " + _vm._s(_vm.personalDetails.surname) + "\n  ")
      ]),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Όνομα" } }, [
        _vm._v("\n    " + _vm._s(_vm.personalDetails.name) + "\n  ")
      ]),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Πατρώνυμο" } }, [
        _vm._v("\n    " + _vm._s(_vm.personalDetails.fatherName) + "\n  ")
      ]),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Μητρώνυμο" } }, [
        _vm._v("\n    " + _vm._s(_vm.personalDetails.motherName) + "\n  ")
      ]),
      _vm._v(" "),
      _vm.activeRole !== "Auditor"
        ? _c("el-form-item", { attrs: { label: "Φύλο" } }, [
            _vm._v("\n    " + _vm._s(_vm.personalDetails.gender) + "\n  ")
          ])
        : _c("el-form-item", { attrs: { label: "Φύλο" } }, [
            _vm._v("\n    ***\n  ")
          ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Χώρα Γέννησης" } }, [
        _vm._v("\n    " + _vm._s(_vm.birthCountryName) + "\n  ")
      ]),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Πόλη γέννησης" } }, [
        _vm._v("\n    " + _vm._s(_vm.personalDetails.birthCity) + "\n  ")
      ]),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Ημερ. Γέννησης" } }, [
        _vm._v("\n    " + _vm._s(_vm.personalDetails.dateOfBirth) + "\n  ")
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _vm.activeRole !== "Auditor"
        ? _c("el-form-item", { attrs: { label: "Διεύθυνση" } }, [
            _vm._v("\n    " + _vm._s(_vm.personalDetails.address) + "\n  ")
          ])
        : _c("el-form-item", { attrs: { label: "Διεύθυνση" } }, [
            _vm._v("\n    *****\n  ")
          ]),
      _vm._v(" "),
      _vm.activeRole !== "Auditor"
        ? _c("el-form-item", { attrs: { label: "Τ.Κ." } }, [
            _vm._v("\n    " + _vm._s(_vm.personalDetails.postcode) + "\n  ")
          ])
        : _c("el-form-item", { attrs: { label: "Τ.Κ." } }, [
            _vm._v("\n    *****\n  ")
          ]),
      _vm._v(" "),
      _vm.activeRole !== "Auditor"
        ? _c("el-form-item", { attrs: { label: "Περιοχή" } }, [
            _vm._v("\n    " + _vm._s(_vm.personalDetails.area) + "\n  ")
          ])
        : _c("el-form-item", { attrs: { label: "Περιοχή" } }, [
            _vm._v("\n    *****\n  ")
          ]),
      _vm._v(" "),
      _vm.activeRole !== "Auditor"
        ? _c("el-form-item", { attrs: { label: "Πόλη" } }, [
            _vm._v("\n    " + _vm._s(_vm.personalDetails.city) + "\n  ")
          ])
        : _c("el-form-item", { attrs: { label: "Πόλη" } }, [
            _vm._v("\n    *****\n  ")
          ]),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Χώρα" } }, [
        _vm._v("\n    " + _vm._s(_vm.countryName) + "\n  ")
      ]),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Τηλέφωνο" } }, [
        _vm._v("\n    " + _vm._s(_vm.personalDetails.telephone) + "\n  ")
      ]),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Κινητό" } }, [
        _vm._v("\n    " + _vm._s(_vm.personalDetails.mobile) + "\n  ")
      ]),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "email" } }, [
        _vm._v("\n    " + _vm._s(_vm.personalDetails.email) + "\n  ")
      ]),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "ΑΦΜ" } }, [
        _vm._v("\n    " + _vm._s(_vm.personalDetails.afm) + "\n  ")
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Πιστοποιητικό" } }, [
        _vm._v("\n    " + _vm._s(_vm.idOrPassport) + "\n  ")
      ]),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Αριθμός" } }, [
        _vm._v("\n    " + _vm._s(_vm.personalDetails.id.number) + "\n  ")
      ]),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.personalDetails.id.idCardOrPassport,
              expression: "personalDetails.id.idCardOrPassport"
            }
          ],
          attrs: { label: "Ημερ. Έκδοσης" }
        },
        [_vm._v("\n    " + _vm._s(_vm.personalDetails.id.issueDate) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.personalDetails.id.idCardOrPassport,
              expression: "!personalDetails.id.idCardOrPassport"
            }
          ],
          attrs: { label: "Ημερ. Λήξης" }
        },
        [_vm._v("\n    " + _vm._s(_vm.personalDetails.id.expireDate) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.personalDetails.id.idCardOrPassport,
              expression: "personalDetails.id.idCardOrPassport"
            }
          ],
          attrs: { label: "Εκδoύσα Αρχή" }
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.personalDetails.id.issueAuthority) + "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.personalDetails.id.idCardOrPassport,
              expression: "!personalDetails.id.idCardOrPassport"
            }
          ],
          attrs: { label: "Χώρα Έκδοσης" }
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.personalDetails.id.issueAuthority) + "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c("hr")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-016a4741", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-016a4741","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PersonalDetails.vue
// module id = null
// module chunks = 